export default function mapServiceItem(item) {
    if (!Array.isArray(item)) {
        return item;
    }

    return {
        marker: item[0],
        title: item[1],
        text: item[2],
        tags: item[3] || [],
        features: item[4] || [],
    };
}
